import LegalShell from '../../components/legal/LegalShell';

export default function About() {
  return (
    <LegalShell title="About Us" version="1.4" effective="2026-10-07">
      <p>
        OculusMind.AI is a platform for autonomous AI agents built by Andrew Paris LLC,
        d/b/a MediaShare-Link (&quot;Company,&quot; &quot;we,&quot; &quot;us,&quot;
        &quot;our&quot;). Our mission is to make capable, transparent AI agents that you can
        both converse with in the browser and integrate directly into your own systems.
      </p>

      <h2>Our vision</h2>
      <p>
        Artificial intelligence should not be a tool reserved for tech nerds. Our vision is
        to enable everyone to put AI to work improving their lives — asking real questions,
        getting cited answers, and handing off the repetitive work — without needing to learn
        a new discipline to do it.
      </p>

      <h2>What our agents do</h2>
      <p>
        Our agents excel at tasks like stock market research and product research. They
        search the live web, dive deep into website content rather than skimming headlines,
        keep documents and memory across conversations, and schedule and automate repeatable
        tasks so the work runs without you. Vera and Maximus can also generate images from
        your descriptions.
      </p>
      <p>
        Our agent <strong>Maximus</strong> is currently in training. He is capable of
        interfacing with and orchestrating any external MCP server, local on-premises
        server, or other APIs on our users&apos; behalf — taking action in outside systems,
        not just reporting on them.
      </p>

      <h2>What makes us different</h2>
      <p>
        We surface the agent&apos;s inner workings rather than hiding them: every tool call,
        its inputs and results, and the agent&apos;s memory are shown as first-class parts of
        the experience. We believe understanding how an agent reaches an answer is as
        valuable as the answer itself.
      </p>

      <h2>Model research and training</h2>
      <p>
        Alongside the platform, our model research and training team fine-tunes open-weight
        language models for agent work and publishes them under Apache&#8209;2.0. Our latest
        release is <a href="https://huggingface.co/OculusMindAI/OculusMind-ToolCall-8B-v2">Pico V2</a>, an
        8-billion-parameter tool-calling model trained on our agents&apos; production tool
        calls. It succeeds our first release,{' '}
        <a href="https://huggingface.co/OculusMindAI/OculusMind-ToolCall-8B-v1">
          OculusMind-ToolCall-8B
        </a>{' '}
        (&quot;Pico&quot;). Benchmarks and downloads for both are on our{' '}
        <a href="/models">Models</a> page.
      </p>

      <h2>Open integration</h2>
      <p>
        Our agents speak the open <strong>Agent-to-Agent (A2A)</strong> protocol, so you can
        call them from your own code or connect them to other agent ecosystems. See the{' '}
        <a href="/integrations">Integrations</a> page to get started.
      </p>

      <h2>Andrew Paris LLC</h2>
      <p>
        Andrew Paris LLC is the home for products founded by Andrew Chud, a software
        engineer with more than 30 years of experience developing technology products across
        multiple industries. Alongside OculusMind.AI, the company&apos;s related products
        include <a href="https://fluffybunny.ai">FluffyBunny.AI</a> and{' '}
        <a href="https://mediashare.link">MediaShare.Link</a>.
      </p>

      <h2>Contact</h2>
      <p>
        Questions, feedback, or partnership inquiries are welcome — see our{' '}
        <a href="/legal/contact">Contact</a> page.
      </p>
    </LegalShell>
  );
}
